export default __webpack_public_path__ + "static/media/challenge_info.ff0bb32d.png";